//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  data() {
    return {}
  },
  created() {
    
  },
  methods: {
  }
}



// WEBPACK FOOTER //
// ./src/components/follow.vue